import React, { Fragment } from 'react';
import styles from './VenueFieldset.scss';
import {Button} from 'reactstrap';
import PropTypes from 'prop-types';
import FormField from '../FormField';
import StateField from '../StateField';
import DropdownField from '../DropdownField';
import InfoLink from '../../InfoLink';

let nameError = (formErrors) => {
  if (formErrors.getIn(['venue', 'name']))
  {
    return 'That doesn\'t look like a venue. If the venue name isn\'t searchable, try searching for the address';
  }
};

const eventElegibilityMessage = (eventElegibility, originPublisherName) => {
  const validLocation = eventElegibility.get('validLocation');
  const validCategory = eventElegibility.get('validCategory');

  if (eventElegibility.get('isLoading') || validLocation === null || validCategory === null || (validLocation
    && validCategory )){
    return;
  }

  return (
    <div className="ineligible-msg">
      <span>Your event will not be published in {originPublisherName} because 
        { !validLocation ? ' it is outside of their coverage area' : ' they only accept specific event categories'}.
      You can still submit your event and it will be published on the Evvnt Calendar. For more information &nbsp;
        <a href={!validLocation ? 'https://support.evvnt.com/hc/en-us/articles/360016368580-Where-is-my-event-' :
          'https://support.evvnt.com/hc/en-us/articles/360017845379'} target="_blank">click here.</a>
      </span>
    </div>
  );
};

const VenueFieldset = ({ onChangeCountry, onChangeZip, formErrors, availableCountries, editMode,
  onClear, onEdit, venue, originPublisherEligibility, originPublisherName }) => {

  const town = (venue && venue.town) ? venue.town : '';
  const state = (venue && venue.state && venue.state.name) ? venue.state.name : '';
  const localityAndArea = [town, state].filter(Boolean).join(', ');

  return (
    <div className={styles.VenueFieldset}>
      {editMode && <Fragment>
        <FormField
          label="Venue Name"
          name="venue.name"
          component="input"
          error={nameError(formErrors)}
          type="text"
          className="form-control"
          required
        />
        <FormField
          label="Address"
          name="venue.address_1"
          error={formErrors.getIn(['venue', 'address_1'])}
          component="input"
          type="text"
          className="form-control"
          placeholder="Address Line 1"
        />
        <FormField
          name="venue.address_2"
          placeholder="Address Line 2"
          error={formErrors.getIn(['venue', 'address_2'])}
          component="input"
          type="text"
          className="form-control"
        />
        <FormField
          placeholder="City"
          name="venue.town"
          error={formErrors.getIn(['venue', 'town'])}
          component="input"
          type="text"
          className="form-control"
        />
        <StateField
          error={formErrors.getIn(['state_name'])}
        />
        <FormField
          placeholder="Zip Code / Post Code"
          name="venue.post_code"
          error={formErrors.getIn(['post_code'])}
          component="input"
          type="text"
          className="form-control"
          onBlur={onChangeZip}
        />
        {availableCountries && <FormField
          error={formErrors.getIn(['venue', 'country', 'iso_alpha2'])}
          name="venue.country"
          component={DropdownField}
          inputProps={{ valueField: 'iso_alpha2', textField: 'name' }}
          data={availableCountries.toJS()}
          type="text"
          className="form-control"
          placeholder="Select a Country"
          onChange={onChangeCountry}
        />}
        <Button className='btn' onClick={()=> onEdit(false)}>
          <i className="fa fa-save"/>
          Save
        </Button>
        <Button className='btn btn-light' onClick={onClear}>
          <i className="fa fa-search"/>
        Reset Location
        </Button>
      </Fragment>
      }
      {!editMode && <div>
        <div>
          <span className="d-block font-weight-bold mb-2">
          Venue Name <span className="text-danger"> *</span>
          </span>
          <span className="d-block">{venue.name}</span>
        </div>
        <div className="mt-3 mb-2">
          <span className="d-block font-weight-bold mb-2">Address</span>
          <span>{venue.address_1}</span>
          {venue.address_2 && <span className="d-block">{venue.address_2}</span>}
          <span className="d-block">{localityAndArea} {venue.post_code}</span>
          { venue.country && venue.country.name && <span className="d-block country">{venue.country.name}</span>}
          <Button className='btn btn-search' onClick={onClear}>
            <i className="fa fa-search"/>
            Reset Location
          </Button>
          <Button className='btn btn-light' onClick={()=> onEdit(true)}>
            <i className="fa fa-edit"/>
            Edit
          </Button>
        </div>
      </div>
      }
      { eventElegibilityMessage(originPublisherEligibility, originPublisherName) }
    </div>
  );
};

VenueFieldset.propTypes = {
  formErrors: PropTypes.object,
  availableCountries: PropTypes.object,
  onChangeCountry: PropTypes.func.isRequired,
  onChangeZip: PropTypes.func.isRequired,
  online: PropTypes.bool,
  editMode: PropTypes.bool,
  onClear: PropTypes.func,
  onEdit: PropTypes.func,
  venue: PropTypes.object,
  originPublisherEligibility: PropTypes.object,
  originPublisherName: PropTypes.string
};

export default VenueFieldset;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/VenueFieldset.jsx